import React, {Component} from 'react';
import {Button} from 'antd';
import CameraModalForm from './CameraModalForm'

class CameraButtonCopy extends Component {
  state = {
    visible: false
  };
  showModal = () => {
    this.setState({visible: true});
  };
  handleCancel = () => {
    this.setState({visible: false});
  };
  handleCopy = () => {
    const form = this.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      this.props.onCopy(values)
      form.resetFields();
      this.setState({visible: false});
    });
  };
  saveFormRef = (form) => {
    this.form = form;
  };
  render() {
    const {camera, categories} = this.props
    return (<span>
      <Button onClick={this.showModal} type="primary" ghost="ghost" size="small">
        Copy
      </Button>
      <CameraModalForm title="Copy camera" camera={camera} categories={categories} ref={this.saveFormRef} visible={this.state.visible} onCancel={this.handleCancel} onSubmit={this.handleCopy}/>
    </span>);
  }
}

export default CameraButtonCopy;



// WEBPACK FOOTER //
// ./src/components/CameraButtonCopy.js